export const dashboardMenu = {
	// dashboardd: {
	// 	id: 'dashboardd',
	// 	text: 'Promotions',
	// 	path: '/',
	// 	icon: 'Dashboard',
	// 	subMenu: null,
	// },
	cusdash: {
		id: 'cusdash',
		text: 'Services',
		path: 'services',
		icon: 'ListAlt',
		subMenu: null,
	},
	Celender: {
		id: 'Celender',
		text: 'Reserve Service',
		path: 'reserve-service',
		icon: 'Dashboard',
		subMenu: null,
	},
	CelenderGuest: {
		id: 'CelenderGuest',
		text: 'Reserve Service Guest',
		path: 'reserve-service-guest',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	Promotion: {
		id: 'Promotion',
		text: 'Our Promotions',
		path: 'promotions',
		icon: 'LocalAtm',
		subMenu: null,
		hide: true,
	},
};

export const demoPages = {
	login: {
		id: 'login',
		text: 'Login',
		// path: 'auth-pages/login',
		path: '/login',
		icon: 'Login',
		hide: true,
	},
	customerActive: {
		id: 'customer_active',
		text: 'Customer Active',
		path: 'customer_active',
		icon: 'Verified',
		hide: true,
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
		hide: true,
	},
	HHome: {
		id: 'hHome',
		text: 'Home',
		path: '/',
		icon: 'PersonAdd',
		hide: true,
	},
	// layoutTypes: {
	// 	id: 'layoutTypes',
	// 	text: 'Customer',
	// },
	privacy: {
		id: 'privacy',
		text: 'privacy',
		path: 'landing/privacy',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	checkout: {
		id: 'checkout',
		text: 'checkout',
		path: 'cart/checkout',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	checkoutGuest: {
		id: 'checkoutGuest',
		text: 'checkoutGuest',
		path: 'cart/checkout_guest',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	forgot: {
		id: 'forgot',
		text: 'forgot',
		path: 'landing/forgot',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	mobileotp: {
		id: 'mobileOTP',
		text: 'mobileOTP',
		path: 'landing/verefiyotp',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	changepw: {
		id: 'changepw',
		text: 'changepw',
		path: 'landing/changepw',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	guestuser: {
		id: 'guestuser',
		text: 'guestuser',
		path: '/guestuser',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
	terms: {
		id: 'terms',
		text: 'Terms',
		path: 'landing/terms',
		icon: 'Dashboard',
		subMenu: null,
		hide: true,
	},
};

export const layoutMenu = {
	cbookingPages: {
		id: 'cus_bookings',
		text: 'My Appointments',
		path: 'knowledge',
		icon: 'AutoStories',
		subMenu: {
			cus_up_book: {
				id: 'cus_up_book',
				text: 'Pending Appointment',
				path: 'appointment/pending',
			},
			cus_completed_book: {
				id: 'cus_completed_book',
				text: 'Completed Appointment',
				path: 'appointment/completed',
			},
			cus_cancelled_book: {
				id: 'cus_cancelled_book',
				text: 'Cancelled Appointment',
				path: 'appointment/cancelled',
			},
		},
	},

	Orders_v: {
		id: 'Orders_v',
		text: 'Orders',
		path: 'orders',
		icon: 'Article',
	},

	Product_v: {
		id: 'Product_v',
		text: 'Products',
		path: 'products',
		icon: 'Storefront',
	},

	// cusrefunds: {
	// 	id: 'cusrefunds',
	// 	text: 'Refunds',
	// 	path: 'cusm-pages/refund',
	// 	icon: 'Payment',
	// },

	Manage_refunds: {
		id: 'Manage_refunds',
		text: 'Refunds',
		path: 'knowledge',
		icon: 'SupervisedUserCircle',
		subMenu: {
			refund_list: {
				id: 'refund_list',
				text: 'Pending Refunds',
				path: 'refunds/pending',
			},
			refund_paid: {
				id: 'refund_paid',
				text: 'Completed Refunds',
				path: 'refunds/completed',
			},
		},
	},

	Promotion: {
		id: 'Promotion',
		text: 'Promotions',
		path: 'promotions',
		icon: 'LocalAtm',
		subMenu: null,
	},

	customervSetting: {
		id: 'cussett',
		text: 'Settings',
		path: 'settings',
		icon: 'Settings',
	},
	view_servwl: {
		id: 'view_servwl',
		text: 'View Services',
		path: 'servicewl',
		hide: true,
	},
	view_productvwl: {
		id: 'view_productvwl',
		text: 'View Products',
		path: 'productwl',
		hide: true,
	},
	v_cartpro: {
		id: 'v_cartpro',
		text: 'ProductCart',
		path: 'productcart',
		hide: true,
	},
	v_cartp: {
		id: 'v_cartp',
		text: 'Cart',
		path: 'cart',
		hide: true,
	},
	v_cartp_guest: {
		id: 'v_cartp_guest',
		text: 'Guest Cart',
		path: 'cart-guest',
		hide: true,
	},
	view_pro: {
		id: 'view_pro',
		text: 'View Products',
		path: 'products',
		hide: true,
	},
	view_serv: {
		id: 'view_serv',
		text: 'View Services',
		path: 'service',
		hide: true,
	},
};

export const productsMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};
